import React from 'react';
import { SettingsProvider } from 'contexts/settings.context';
import SettingsContent from './content';

const SettingsLayout = () => {
  return (
    <SettingsProvider>
      <SettingsContent />
    </SettingsProvider>
  );
};

export default SettingsLayout;
